import { Table, Column, Cell, ColumnHeaderCell } from 'callahan-react'
import React from 'react'

import { formatDate } from '../../utils/date-utils.js'

class SiteTable extends React.Component {
  renderCell = (index, prop, modifier) => {
    const { displayData } = this.props
    const data = displayData[index]
    return (
      <Cell key={data.id} className="ui-cell">
        <h4 className="cell-header">
          {typeof modifier !== 'undefined' ? modifier(data[prop]) : data[prop]}
        </h4>
      </Cell>
    )
  }

  renderSiteIdCell = rowIndex => this.renderCell(rowIndex, 'id')

  renderPcodeCell = rowIndex => {
    const { displayData } = this.props
    const data = displayData[rowIndex]
    return (
      <Cell key={data.id} className="ui-cell">
        <a className="cell-header" href={'/measure/profile/network/p-' + data.pcode}>
          {data.pcode}
        </a>
      </Cell>
    )
  }

  renderNameCell = rowIndex => {
    const { displayData } = this.props
    const data = displayData[rowIndex]
    return (
      <Cell key={data.id} className="ui-cell">
        <a className="cell-header" href={'/measure/profile/site/p-' + data.pcode + '/' + data.name}>
          {data.name}
        </a>
      </Cell>
    )
  }

  renderQuantifiedDateCell = rowIndex => this.renderCell(rowIndex, 'quantifiedDatetime', formatDate)

  render() {
    const { displayData } = this.props
    const cols = [
      {
        title: 'Site ID',
        key: 'id',
        render: this.renderSiteIdCell
      },
      {
        title: 'Publisher ID',
        key: 'pcode',
        render: this.renderPcodeCell
      },
      {
        title: 'Website',
        key: 'name',
        render: this.renderNameCell
      },
      {
        title: 'Quantified Date',
        key: 'quantifiedDatetime',
        render: this.renderQuantifiedDateCell
      }
    ].map(col => {
      return (
        <Column
          key={col.key}
          header={
            <ColumnHeaderCell key={col.key + '-header'}>
              <h4>{col.title}</h4>
            </ColumnHeaderCell>
          }
          renderCell={col.render}
          grow={true}
        />
      )
    })

    return (
      <div>
        <div className="site-info-table-holder">
          <Table displayData={displayData} grow={true}>
            {cols}
          </Table>
        </div>
      </div>
    )
  }
}
export default SiteTable



// WEBPACK FOOTER //
// ./src/pages/SiteInfo/SiteTable.js